export default {
  app: 'NebulaRec',
  common: {
    lang: '中文',
    call: '联系电话：',
    company: '掌禅无线科技',
    mail: '商务邮箱：',
    address: '联系地址：上海市静安区亚龙创业园七号楼307室',
    owner: '版权所有者：上海掌禅无线科技有限公司',
    alertInfo1: '点击右上角菜单',
    alertInfo2: '在浏览器打开页面下载'
  },
  videoPage: {
    eyebrow: '产品视频',
    title: '用视频，快速了解 NebulaRec',
    description: '选择中文或英文版本，观看 NebulaRec 的产品介绍与使用方式。',
    selectLanguage: '选择视频语言',
    chinese: '中文版',
    english: 'English',
    current: '正在播放',
    unavailableTitle: '视频即将上线',
    unavailableText: '视频文件准备好后将在这里播放。',
    hint: '支持播放、暂停、音量调节、进度拖动和全屏观看。',
    loadError: '视频暂时无法加载，请稍后重试。'
  },
  banner: {
    slogan: '录音即时翻译，语言不再是障碍！',
    slogan2: '智能录音，实时转录翻译，让沟通无界限',
    download: '立即下载'
  },
  introduction: {
    meeting: '会议记录',
    meetingIn: '现场录音转文字 海量会议模板 思维导图',
    translation: '实时翻译',
    translationIn: '实时响应，翻译快人一步',
    cross: '跨平台翻译',
    crossIn: '跨越平台界限，翻译始终相伴',
    offline: '离线翻译',
    offlineIn: '离线不 “失联”，翻译随时见分享'
  },
  scene: {
    title: '六大应用场景',
    meeting: '·商务会议',
    meetingIn: '跨国会议，语言无碍——实时录音转译，精准捕捉每一条决策要点',
    travel: '·旅行沟通',
    travelIn: '跨国旅行，语言无碍 —— 口音自适应识别，方言外语都能清晰转译',
    study: '·学习进修',
    studyIn: '外语课堂/讲座一键录，AI转译+重点标记，学习效率翻倍。',
    exchange: '·跨国社交',
    exchangeIn: '录音即翻译，交友无国界——派对、聚会，再也不怕听不懂',
    interview: '·采访调研',
    interviewIn: '跨语言访谈神器——原音记录+即时翻译，还原受访者的每一分真实。',
    emergency: '·应急场景',
    emergencyIn: '紧急情况，长按录音——医疗/问路关键信息，快速翻译保安全'
  },
  describe: {
    record: '录音转写：精准捕捉，一键成文',
    recordIn: '支持多种主流语言，在嘈杂环境下，凭借噪声抑制和语音增强技术，利用AI技术上下文修正，提高准确率。',
    summary: 'AI总结：提炼精华，洞察核心',
    summaryIn: '集成了 ChatGPT，并且可提供多种格式，帮助用户快速提取关键信息，节省时间和精力。',
    map: '生成思维导图：可视化呈现，构建知识网络',
    mapIn: '挖掘文本中的层级关系和逻辑联系,转化为可视化的思维导图，以节点和连线的形式清晰展示知识脉络。'
  },
  download: {
    apple: 'App Store',
    google: 'Play 商店',
    honor: '荣耀应用商店',
    android: '安卓下载',
    huawei: '华为应用市场',
    mi: '小米应用商店',
    oppo: 'OPPO软件商店',
    vivo: 'VIVO应用商店',
    appstore: '请前往手机应用商店下载'
  },
  share: {
    icode: '邀请码',
    notice: '购买合作录音笔后，您可以在NebulaRec内兑换好友邀请码，获得免费转写时长！',
    copy: '复制邀请码',
    success: '已复制'
  },
  hexinyingyong: {
    title: '核心功能',
    t1: '实时语音转录',
    j1: '多语言高精度识别',
    t2: '实时翻译',
    j2: '边录边译，即时呈现',
    t3: '总结摘要',
    j3: 'AI提取要点，生成纪要',
    t4: '声纹识别',
    j4: '自动区分不同发言者',
    t5: '知识库',
    j5: '长记忆管理&知识问答',
    t6: '术语库',
    j6: '专业领域转写更准确',
    title2: '应用场景',
    t7: '国际会议',
    j7: '实时记录翻译，提高效率',
    t8: '跨境电商',
    j8: '无障碍沟通，促进合作',
    t9: '语言教育',
    j9: '辅助学习，记录发音',
    t10: '旅行 & 社交',
    j10: '出行必备，轻松交流',
    t11: '跨语言协作',
    j11: '长记忆管理&知识问答',
    t12: '项目管理',
    j12: '会议记录，自动归档'
  }
}
